"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = _interopRequireDefault(require("../../../base/security/1.0/index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module upper/url_handler/1_0
 * @author Chancechen <chancechen@lexin.com>
 * @version 1.0
 * @description [收拢通用url处理相关方法]
 */
// security组件
// 全局变量定义
var G_DEFAULT_PROTOCOL = 'https://'; // 默认https

var Url = {
  /**
   * @function getDefaultProtocol  
   * @description 获取默认协议
   * @version 2.0
   * @instance
   * @returns {string}
   * @example
   * Protocol.getDefaultProtocol(); //return 'https://'
   */
  getDefaultProtocol: function getDefaultProtocol() {
    return G_DEFAULT_PROTOCOL;
  },

  /**
   * @function addUrlProtocol
   * @param {string} url 链接
   * @param {function} callback_openurl 回调函数
   * @description 补充url协议
   * @version 2.0
   * @instance
   * @returns {string}
   * @example
   * Protocol.addUrlProtocol('m.fenqile.com'); //return 'https://m.fenqile.com'
   */
  addUrlProtocol: function addUrlProtocol(url, callback_openurl) {
    if (!url) {
      return false;
    } // 默认协议头https


    var default_protocol = this.getDefaultProtocol(),
        // 站内域名协议头匹配
    reg_all = /^(http:\/\/|https:\/\/|\/\/|)[\w\-_.]+(fenqile|juzilicai|mycaidan|mac4me|tsbxdl|tonghuafund|leka)\.(cn|com|club)/,
        // 待更换协议头匹配 http https
    reg_prefix = /^(http:\/\/|https:\/\/|\/\/|)/; // 直接替换
    // 如果是站内域名，走https

    if (reg_all.test(url)) {
      url = url.replace(reg_prefix, default_protocol);
    } else {
      // 站外域名协议头匹配
      // 包括scheme逻辑，以开头  字母:// 的规则进行匹配
      var reg_prefix_protocol = /^(\w+):(\/\/)/; // 没有协议头，则加上协议头http

      if (!reg_prefix_protocol.test(url)) {
        url = url.replace(reg_prefix, 'http://');
      }
    }

    if (!callback_openurl) {
      // 站内请求只需要添加协议
      return url;
    } else {
      // 跳转在回调完成
      if (typeof callback_openurl == 'function') {
        callback_openurl(url); // 页面跳转在回调处理
      }
    }
  },

  /**
   * @function getParameter
   * @param {string} name 参数名[必选]
   * @param {string} url 解析参数的url [必选]
   * @author Chancechen <chancechen@lexin.com>
   * @description [从传入url的qs参数中获取指定的参数]
   * @instance
   * @return {string}
   * @example
   * M_Url.getParameter('a', '//a.com/S123.html?a=123&b=456'); //return '123';
   */
  getParameter: function getParameter() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var ret = '';

    if (name && url) {
      var params = this.parse(url);
      ret = params[name] || ret;
    }

    return ret;
  },

  /**
   * @function joinParams
   * @param {string} url 需要拼接的url[必选]
   * @param {object} params 需要添加至url的参数对象 [可选]
   * @author Chancechen <chancechen@lexin.com>
   * @description  [拼接请求参数]
   * @instance
   * @returns {string} url
   * @example
   * Url.joinParams('//a.com/S123.html', {a: 132, b: 456}); //return '//a.com/S123.html?a=123&b=456';
   */
  joinParams: function joinParams() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var href = ''; // 判断url中是否已存在?，若不存在，则在后面补充?

    if (url.indexOf('?') < 0) {
      href = href.concat(url, '?');
    } else {
      href = href.concat(url, '&');
    } // 遍历入参，若key为空或者undefined则跳过该参数


    for (var key in params) {
      if (key == 'undefined' || !key) {
        continue;
      } else {
        // 拼接参数
        href = href.concat(key, '=', encodeURIComponent(params[key]), '&');
      }
    } // 将多余的字符（?或者&）移除


    href = href.substr(0, href.length - 1);
    return href;
  },

  /**
   * @function parse
   * @param {string} url 需要解析的url[必选]
   * @author Chancechen <chancechen@lexin.com>
   * @description  [将url中的参数解析为对象]
   * @instance
   * @returns {object} {a: '123', b: '456'}
   * @example
   * Url.parse('//a.com/S123.html?a=123&b=456'); //return {a: '123', b: '456'};
   */
  parse: function parse() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (!url) {
      return {};
    }

    var re = /[?&]([^?&=]+)=([^&]+)/g,
        matcher = re.exec(url),
        // 匹配&=间的key，value
    items = {}; // 若不为null，则进行赋值

    while (null !== matcher) {
      try {
        // 异常处理: 如链接上参数带有%导致decodeURL报错
        items[matcher[1]] = _index["default"].zeroSpaceFilter(decodeURIComponent(matcher[2])); // 解码后进行零宽字符过滤
      } catch (e) {
        console.error(e);
      }

      matcher = re.exec(url);
    }

    return items;
  },

  /**
   * @function isUrl
   * @description 是否为正确的链接
   * @param {String} url 链接
   * @returns {Boolean} 返回true或false
   * @instance
   * @example
   * M_URL.isUrl('https://xxx.com') // true
   */
  isUrl: function isUrl(url) {
    // 链接正则
    var regStr = '^(((https|http):)?//)' + // 协议 https或http
    '([\\w_!~*\'()-]+\\.)*' + // 域名 至少一个[ 英文 或 数字_!~*\'()-]加上.
    '\\w+\\.' + // 二级域名
    '([a-z]{2,6})' + // 顶级域名
    '(:[0-9]{1,5})?'; // 端口- :80

    var reg = new RegExp(regStr);
    return reg.test(url);
  }
};
var _default = Url;
exports["default"] = _default;